import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.notice');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-page-admin-notice',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.notice/view.scss */
/* src/app/page.admin.notice/view.scss: no such file or directory */`],
})
export class PageAdminNoticeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public docID: any;
    public category: any;

    public async ngDoCheck() {
        this.category = WizRoute.segment.category;
        this.docID = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("공지사항 관리 - MY KREONET");

        await this.service.render();
    }
}

export default PageAdminNoticeComponent;